// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20261001.1790886124/static/js/" + chunkId + "." + {"249":"262faa4b","463":"8a875d0b"}[chunkId] + ".chunk.js";
};